import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'time'
})
export class TimePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(time: string, format: string = 'h:mm a'): string {
    const date = new Date();
    if (time.includes(':')) {
      const hours = Number(time.split(':')[0]);
      const minutes = Number(time.split(':')[1]);
      date.setHours(hours, minutes);
      return this.datePipe.transform(date, format) || '';
    } else {
      return '';
    }
  }

}
